import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialItemTemplatesApi = {
    getTrialItemTemplates: (trialId: number): Observable<Dtos.GetTrialItemTemplatesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialItemTemplates = new Dtos.GetTrialItemTemplates();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialItemTemplatesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialItemTemplateById: (id: number): Observable<Dtos.GetTrialItemTemplateByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialItemTemplateById = new Dtos.GetTrialItemTemplateById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialItemTemplateByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialItemTemplate: (trialItemTemplate: Dtos.TrialItemTemplate, collection: Dtos.Collection): Observable<Dtos.SetTrialItemTemplateResponse> => {

        let request: Dtos.SetTrialItemTemplate = new Dtos.SetTrialItemTemplate();

        request.trialItemTemplate = trialItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.SetTrialItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialItemTemplate: (trialId: number): Observable<Dtos.CreateTrialItemTemplateResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialItemTemplate = new Dtos.CreateTrialItemTemplate();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.CreateTrialItemTemplateResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialItemTemplate: (trialItemTemplate: Dtos.TrialItemTemplate, collection: Dtos.Collection): Observable<Dtos.ValidateTrialItemTemplateResponse> => {

        let request: Dtos.ValidateTrialItemTemplate = new Dtos.ValidateTrialItemTemplate();

        request.trialItemTemplate = trialItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.ValidateTrialItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
}